import { useState } from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { Bars } from "./Bars";

const CHANNELS = [["instagram", "Instagram"], ["youtube", "YouTube"], ["site", "Site da igreja"], ["campanha", "Campanhas"], ["outros", "Outros canais"]];
const LABELS = Object.fromEntries([...CHANNELS, ["nao_identificada", "Origem não identificada"]]);
const slug = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const copy = async (url) => {
  try { await navigator.clipboard.writeText(url); toast.success("Link copiado"); } catch { toast.error("Não foi possível copiar"); }
};

const LinkRow = ({ id, label, url }) => (
  <li className="flex min-w-0 items-center gap-2 text-sm">
    <span className="w-24 shrink-0 font-medium sm:w-28">{label}</span>
    <code data-testid={`origin-link-${id}`} title={url} className="min-w-0 flex-1 truncate rounded bg-zap-mist px-2 py-1 text-xs" dir="rtl"><bdi>{url}</bdi></code>
    <button data-testid={`origin-copy-${id}`} onClick={() => copy(url)} aria-label={`Copiar link ${label}`} className="rounded-md p-1.5 hover:bg-zap-line"><Copy className="h-4 w-4" /></button>
  </li>
);

const Links = () => {
  const [name, setName] = useState("");
  const base = `${window.location.origin}/?origem=`;
  return (
    <section className="min-w-0 space-y-3">
      <h2 className="font-display text-base font-semibold">Links de divulgação</h2>
      <p className="text-sm text-muted-foreground">Use um link para cada canal. Quem se cadastrar depois de abrir o link fica com essa origem registrada.</p>
      <ul className="space-y-2">
        {CHANNELS.filter(([k]) => k !== "campanha").map(([k, l]) => <LinkRow key={k} id={k} label={l} url={base + k} />)}
      </ul>
      <div className="space-y-2 pt-2">
        <input data-testid="campaign-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome da campanha (ex.: Culto de Natal)"
          className="h-9 w-full max-w-80 rounded-md border border-zap-line px-2 text-sm" />
        {slug(name) && <ul><LinkRow id="campanha" label="Campanha" url={`${base}campanha&campanha=${slug(name)}`} /></ul>}
      </div>
    </section>
  );
};

export const Origins = ({ origins, campaigns }) => (
  <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
    <div className="min-w-0 space-y-8">
      <Bars testId="reports-origins" title="Origem dos participantes" labels={LABELS} keepOrder
        data={[...CHANNELS, ["nao_identificada"]].map(([k]) => [k, origins[k] || 0]).filter(([k, v]) => v || k !== "nao_identificada")} />
      <p className="text-xs text-muted-foreground">Só aparece a origem de quem entrou por um link identificado. Quem abriu o endereço direto fica como "não identificada".</p>
      {Object.keys(campaigns).length > 0 && <Bars testId="reports-campaigns" title="Por campanha" data={campaigns} />}
    </div>
    <Links />
  </div>
);
